angular.module('rightPaneModule')
    .directive('dblLessonActivity', ['$filter', '$compile', 'dblLessonService', '$modal', 'navigation',
        function($filter, $compile, dblLessonService, $modal, dblNavigation) {
        // This directive renders the core html of the lesson complete and lesson paused cards.
        var LESSON_PAUSED_SUBHEADER_HTML = '<span> {{ "reports.studentMayNeedAttentionOnLesson" | translate }} <strong>{{ getUnsuccessfulText() }}</strong></span>';

        return {
            restrict: 'E',
            templateUrl: '/resources/right-pane/components/activity-feed/dbl-lesson-activity.directive.html',
            scope: {
                dblActivity: '=',
                dblShowStudentName: '=',
                dblUseUxEaseOfUse: '=',
            },
            link: function(scope, element) {

                scope.oldTemplateUrl  = '/resources/right-pane/components/activity-feed/old-activity-templates/dbl-lesson-activity.directive.html';

                scope.$watch('dblActivity', function (newVal) {
                    if (!newVal) {
                        return;
                    }

                    var template = scope.dblActivity.isLessonStrugglingActivity() ?
                        LESSON_PAUSED_SUBHEADER_HTML :
                        scope.getSubHeaderHtml();

                    var subheaderContent = $compile(template)(scope);

                    element
                        .find('.activity-header-text-2')
                        .empty()
                        .append(subheaderContent);
                });

                scope.getActivityBadgeImage = function () {
                    var imageBase = 'resources/images/';
                    var fileName;

                    if (scope.dblActivity.isLessonPausedActivity()) {
                        fileName = 'pause-circle.png';
                    } else if (scope.dblActivity.isLessonStrugglingActivity()) {
                        fileName = 'alert.png';
                    } else if (scope.dblActivity.isLessonGroupActivity && scope.dblActivity.isLessonGroupActivity()) {
                        fileName = 'complete.png';
                    } else {
                        fileName = scope.dblActivity.lessonPassed ? 'check-green-circle.png' : 'check-grey-circle.png';
                    }

                    return imageBase + fileName;
                };

                scope.getDemoLessonSlotName = function () {
                    return scope.dblActivity.lessonSlotName;
                };

                scope.getDemoLink = function () {
                    return dblLessonService.getDemoLink(scope.dblActivity.lessonSlotName);
                };

                scope.getHeaderText = function () {
                    var header = scope.dblActivity.localizedLessonName ?
                        scope.dblActivity.localizedLessonName :
                        scope.dblActivity.dblStandard.short_description;
                    return $filter('translate')('curriculumData.' + header, { defaultValue: header });
                };

                scope.getLessonImage = function () {
                    if (!scope.dblActivity.dblStandard) {
                        return '';
                    }

                    return dblLessonService.getImageForDblStandard(scope.dblActivity.dblStandard.name);
                };

                scope.getLessonStatusText = function () {
                    var text = scope.dblActivity.assignmentId ?
                        $filter('translate')(dblLessonService.ASSIGNED) + ' ' :
                        '';


                    text += $filter('translate')(
                        scope.dblActivity.isLessonPausedActivity() ?
                            dblLessonService.LESSON_STATUS.PAUSED :
                            dblLessonService.LESSON_STATUS.COMPLETED
                    );
                    return text;
                };

                scope.getStatusBadgeText = function () {
                    if (scope.dblActivity.isLessonPausedActivity() || scope.dblActivity.isLessonStrugglingActivity()) {
                        return '';
                    }

                    try {
                        return dblLessonService.getCompletedInstanceCountString(scope.dblActivity.lessonCompletedInstanceCount);
                    } catch (e) {
                        return '';
                    }
                };

                scope.getSubHeaderHtml = function () {
                  if (scope.getUnderstandingText() && !scope.dblActivity.isLessonPausedActivity()) {
                    return '<span ng-bind-html="\'reports.lessonStatusWithUnderstandingText\' | translate: {lessonStatus: (getLessonStatusText() | translate), understandingText: (getUnderstandingText() | translate)}"></span>';
                  }

                  if (scope.getUnderstandingText()) {
                    return '<span ng-bind-html="getLessonStatusText() | translate"></span>' +
                      '<span class="understanding-text" ng-bind-html="getUnderstandingText() | translate"></span>';
                  }

                  return '<span ng-bind-html="getLessonStatusText() | translate"></span>';
                };

                scope.getUnderstandingText = function () {
                    if (scope.dblActivity.isLessonPausedActivity() || !_.isBoolean(scope.dblActivity.lessonPassed)) {
                        return '';
                    }

                    var key = scope.dblActivity.lessonPassed ?
                        dblLessonService.LESSON_UNDERSTANDING.YES :
                        dblLessonService.LESSON_UNDERSTANDING.NO;
                    return $filter('translate')(key);
                };

                scope.getUnderstandingClass = function () {
                  if(scope.dblActivity.isLessonStrugglingActivity()) {
                    return 'activity-tone-warn';
                  }

                  if (scope.dblActivity.isLessonPausedActivity()) {
                    return '';
                  }

                  return scope.dblActivity.lessonPassed ? 'activity-tone-good' : '';
                };

                scope.getUnsuccessfulText = function () {
                  var count = scope.dblActivity.lessonFailedCount;
                  if (count > 4) {
                    return $filter('translate')('reports.times.fivePlus');
                  }
                  var timeKeys = ['', 'reports.times.first', 'reports.times.second', 'reports.times.third', 'reports.times.fourth'];
                  return timeKeys[count] ? $filter('translate')(timeKeys[count]) : count;
                };

                scope.getWithText = function () {
                  return $filter('translate')('with');
                };

                scope.openMilestoneCompletedLetterModal = function () {
                    var modal = $modal.open({
                        templateUrl: 'resources/core/partials/milestone-completed-letter-modal.html',
                        windowClass: 'milestone-completed-letter-modal',
                        controller: 'MilestoneCompletedLetterModalController',
                        resolve: {
                            dblActivity: function () {
                                return scope.dblActivity;
                            }
                        }
                    });
                };

                scope.studentClicked = function() {
                  var studentId = scope.dblActivity.id;
                  var student = {
                    id: studentId,
                    type: 'student'
                  };
                  var overrideParams = {
                    pane: 'activity'
                  };

                  dblNavigation.goToItem(student, overrideParams);
                };
            }
        };
    }]);
